import * as tinycolor from 'tinycolor2'

function makeGqlFilter (vuexFilter) {
  if (vuexFilter.type === 'price') {
    return {
      field: 'Price',
      between: vuexFilter.values
    }
  } else if (vuexFilter.type === 'colour') {
    return {
      field: 'Option',
      subfield: 'colour',
      in: vuexFilter.values.map(v => JSON.stringify(v))
    }
  } else {
    return {
      field: 'Attribute',
      subfield: vuexFilter.type,
      in: vuexFilter.values
    }
  }
}

export function makeSearchFilter (searchTerm) {
  let filter = { and: [] }

  for (const word of (searchTerm || '').split(' ')) {
    filter.and.push(makeSearchFilterForSingleTerm(word))
  }

  return filter
}

function makeSearchFilterForSingleTerm (searchTerm) {
  let filter = { or: [] }

  filter.or.push({
    field: 'Name',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Reference',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'brand',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'range',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'size',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'grip',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'material',
    contains: searchTerm
  })

  filter.or.push({
    field: 'Attribute',
    subfield: 'manufacturer',
    contains: searchTerm
  })

  return filter
}

export const productFilterGql = (state) => {
  if (!state.filters.length && !state.search) return {}

  let rootGqlFilter = { and: [] }

  // Want to and all filters
  state.filters.forEach(filter => {
    rootGqlFilter.and.push(makeGqlFilter(filter))
  })

  if (state.search) {
    rootGqlFilter.and.push(makeSearchFilter(state.search))
  }

  return rootGqlFilter
}

let hexToIntMap = {}
// This function is called a LOT and is quite slow so I've cached it.
function hexToInt (hex) {
  if (!(hex in hexToIntMap)) {
    hexToIntMap[hex] = tinycolor(hex).getBrightness()
  }
  return hexToIntMap[hex]
}

export const colourSuperGroups = (state) => {

  
  const desiredOrder = ['Yellow', 'Blue', 'Purple', 'Green', 'Red', 'Orange', 'Black', 'White']

  // Get all unique values
  // const allGroups = [...new Set(state.colours.map(v => v.group))]
  const superGroups = [...new Set(state.colours.map(v => v.superGroup))]

  
  // Map sub colours under each group
  const returnVal = superGroups.map(superGroup => {
    const superGroupColours = state.colours.filter(v => v.superGroup === superGroup)
    const groups = [...new Set(superGroupColours.map(v => v.group))]
    const groupValues = groups.map(group => {
      const colours = state.colours.filter(v => v.group === group).sort((a, b) => hexToInt(a.hex) - hexToInt(b.hex))
      return {
        hex: colours[0].hex,
        name: group,
        colours
      }
    }).sort((a, b) => hexToInt(a.hex) - hexToInt(b.hex))
    return {
      hex: superGroupColours[0].hex,
      name: superGroup,
      groups: groupValues
    }
  }).sort((a, b) => {
    const aIndex = desiredOrder.indexOf(a.superGroup)
    const bIndex = desiredOrder.indexOf(b.superGroup)
    const aVal = aIndex < 0 ? 99999 : aIndex
    const bVal = bIndex < 0 ? 99999 : bIndex
    return aVal - bVal
  })

  return returnVal
}

export const colourGroups = (state) => {

  
  // Get all unique values
  const groups = [...new Set(state.colours.map(v => v.group))]
  // Map sub colours under each group
  return groups.map(group => {
    let colours = state.colours.filter(v => v.group === group)
    return {
      hex: colours[0].hex,
      name: group,
      colours
    }
  })
}
